import { EditorInput } from '../EditorInput';
import { customizeCraftJsComponent } from '../../helpers';

export const EditorLastNameInput = customizeCraftJsComponent(EditorInput, {
	name: 'Last Name Input',
	props: {
		name: 'lastName',
		type: 'text',
		placeholder: 'Last Name',
		label: 'Last Name'
	}
});
